module.exports = __webpack_public_path__ + "img/bolPng.91af8550.png";